import React from 'react'
import StyledSlider from '@e3dc-react/shell/Elements/Slider/StyledSlider'

const STEP = 1
const MIN = 0
const MAX = 100

interface Props {
  value: number
  onChange: (value: number) => void
  chargeLimitMax?: number
}

/**
 * Slider component to select the minimum state of charge of the vehicle
 */
const MinimumStateOfChargeSlider: React.VFC<Props> = ({ value, onChange, chargeLimitMax }) => {
  const handleChange = (event: Event, newValue: number | number[]): void => {
    onChange(newValue as number)
  }

  return (
    <StyledSlider
      min={MIN}
      max={MAX}
      step={STEP}
      value={value}
      onChange={handleChange}
      marks={chargeLimitMax ? [{ value: chargeLimitMax, label: '' }] : undefined}
    />
  )
}

export default MinimumStateOfChargeSlider
